import { Textarea as HeadlessTextarea } from '@headlessui/react'
import { TextareaHTMLAttributes, forwardRef } from 'react'
import { cn } from '@/common/utilities.ts'

type Props = TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <HeadlessTextarea
        ref={ref}
        className={cn(
          'text-gray-800 border-gray-200 w-full rounded-md text-sm',
          className
        )}
        {...props}
      />
    )
  }
)

// Add display name for better debugging
Textarea.displayName = 'Textarea'

export default Textarea
